export default __webpack_public_path__ + "static/media/hht1_storybook_10.aed0d25b.png";